module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mrescir4-72826b81126e94507ddb219376d0635f.jpg";